import { jsx as _jsx } from "react/jsx-runtime";
import { Theme } from '@streem/ui-react';
import { CallDetailsIcon } from './tool_styles';
import { normalizeAudioLevel } from '../../../../util/normalize_audio_level';
import { useObservable } from '../../../../hooks/rxjs';
import { useRoomSession } from '../../../../context/room_session';
export const RemoteAudioStatus = ({ remoteAudioEnabled = false }) => {
    const roomSession = useRoomSession();
    const [remoteAudioLevel] = useObservable(roomSession.media.remoteAudio.audioLevel);
    return remoteAudioEnabled ? (_jsx(CallDetailsIcon, { filllevel: normalizeAudioLevel(remoteAudioLevel), name: "MuteIcon", color: Theme.colors.grey90, "data-testid": "toolbar-mute-icon", style: { transform: 'scale(0.9)' } })) : (_jsx(CallDetailsIcon, { name: "MutedIcon", color: Theme.colors.red50, slashcolor: Theme.colors.red50, "data-testid": "toolbar-muted-icon", style: { transform: 'scale(0.9)' } }));
};
//# sourceMappingURL=remote_audio_status.js.map